import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modificationgenerale',
  templateUrl: './modificationgenerale.component.html',
  styleUrls: ['./modificationgenerale.component.css']
})
export class ModificationgeneraleComponent {

  // data contiendra l'objet passé lors de l'ouverture du dialog
  constructor(
    public dialogRef: MatDialogRef<ModificationgeneraleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}


  ngOnInit(): void {
  }


  // Fermer sans sauvegarde
  onCancel(): void {
    this.dialogRef.close(null);
  }

  // Sauvegarder et renvoyer l'objet modifié
  onSave(): void {
    this.dialogRef.close(this.data);
  }
}
